export default {
  getRecommendations(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`rewards/reference/my-recommendations?${queryString}`)
        .then(({ data: { results, next, previous, count } }) => {
          context.commit("setRecommendations", results);
          context.commit("setPagination", { next, previous, count });
          resolve({ data: { results, next, previous, count } });
        })
        .catch(reject);
    });
  },
  exportRecommendations(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`rewards/reference/my-recommendations?${queryString}`)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },
  getReference(context) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get("rewards/reference")
        .then(({ data: { refer } }) => {
          context.commit("setRecommendationProfile", refer);
          resolve(refer);
        })
        .catch(reject);
    });
  },
  getRecommendationTotal(context) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get("rewards/reference/total")
        .then(({ data: { total_pending } }) => {
          context.commit("setRecommendationTotal", total_pending);
          resolve(total_pending);
        })
        .catch(reject);
    });
  },
  acceptTerms(context) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`rewards/reference/accept-terms`)
        .then(resolve)
        .catch(reject);
    });
  },
  getComissions(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`rewards/reference/mine?${queryString}`)
        .then(({ data: { previous, next, count, results } }) => {
          context.commit("setComissions", results);
          resolve({ previous, next, count, results });
        })
        .catch(reject);
    });
  },
  exportComissions(context, params) {
    return new Promise((resolve, reject) => {
      const config = params.type === "excel" ? { responseType: "blob" } : null;
      const queryString = new URLSearchParams({
        ...params,
        export: true
      }).toString();
      return window.axios
        .get(`rewards/reference/mine?${queryString}`, config)
        .then(resolve)
        .catch(reject);
    });
  }
};
